import { Flashbar, ProgressBar, SegmentedControl } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../../commons/functions';
import { useGlobalState } from '../../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../../layout';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiAirplane, mdiGasStation, mdiHelicopter } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import DPModal from '../../../../../../components/DPModal';
import Favorites from '../../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
const _preserve = React.version;

export const OPSFuelTanksLevelsPage = () => {
    const { menu, parameters, data } = useGlobalState();

    const [type, setType] = useState("");




    const [tank, setTank] = useState<any>();




    useEffect(() => {
        handleCheckFuel();
    }, [type, parameters.date]);
    const handleCheckFuel = async () => {
        if (parameters && parameters.date && type !== "") {
            try {
                setLoading(true)

                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/tanks/levels',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        isFuel: true,
                        fuelType: type,
                        date: parameters.date,
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setTank(data.tank);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }
        }
    }
    const capacity = tank ? (tank.load - tank.liters) / (type === "AVGAS" ? 20000 : 30000) * 100 : 0;

    //
    return (
        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />} //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >
                            Nivel de estanques
                        </Header>
                        <SpaceBetween direction='vertical' size='xs'>

                            <SpaceBetween direction="horizontal" size="xs">
                                <SegmentedControl
                                    selectedId={type}
                                    onChange={({ detail }) => {
                                        setType(detail.selectedId)
                                    }}
                                    label="Tipo combustible"
                                    options={[
                                        { text: "AVGAS", id: "AVGAS" },
                                        { text: "JP1", id: "JP1" },
                                    ]}
                                />
                                <DPModal date={parameters.date}
                                    today
                                    end={new Date()}
                                    onConfirm={(date) => {
                                        setParameters({ ...parameters, date: date });
                                    }} />


                            </SpaceBetween>
                            {!!tank && (
                                <div style={{ maxWidth: 400 }}>
                                    <Flashbar
                                        items={[
                                            {
                                                content: (
                                                    <ProgressBar
                                                        value={capacity}
                                                        variant="flash"
                                                        additionalInfo={<>Carga copec al {tank.measureDate}: <strong>{new Intl.NumberFormat('es-CL').format(tank.load)}/{new Intl.NumberFormat('es-CL').format(type === "AVGAS" ? 20000 : 30000)} litros</strong></>}
                                                        description={<>Consumos {type == "AVGAS" ? <Icon path={mdiAirplane} size={1} /> : <Icon path={mdiHelicopter} size={1} />} al {parameters.date}: <strong>{new Intl.NumberFormat('es-CL').format(tank.liters)}</strong> {" en "}<Icon path={mdiGasStation} size={0.75} />{tank.loads}{" cargas"}</>}
                                                        label={<>Nivel del estanque: <strong>{new Intl.NumberFormat('es-CL').format(tank.load - tank.liters)} litros</strong></>}
                                                    />
                                                ),
                                                type: capacity <= 10 ? "error" : capacity <= 30 ? "warning" : "in-progress",
                                                dismissible: false,
                                                id: "progressbar_1"
                                            }
                                        ]}
                                    />
                                </div>

                            )}
                        </SpaceBetween>
                    </SpaceBetween>


                </>
            } />
    );
};
